import React from "react";
import { Link } from "react-router-dom";
import { Brain, ArrowRight } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Industries: [
      { label: "Education", to: "/education" },
      { label: "Healthcare", to: "/healthcare" },
      { label: "Real Estate", to: "/real-estate" },
      { label: "Financial Services", to: "/financial-services" },
      { label: "Retail & Commerce", to: "/retail" },
      { label: "Hospitality", to: "/hospitality" },
    ],
    Products: [
      { label: "AI Voice Agents", href: "#products" },
      { label: "AI WhatsApp Agents", href: "#products" },
      { label: "AI Sales Agents", href: "#products" },
      { label: "AI Marketing Agents", href: "#products" },
      { label: "Support Agents", href: "#products" },
      { label: "Workflow Automation", href: "#products" },
    ],
    Company: [
      { label: "About Us", href: "#" },
      { label: "Custom Solutions", href: "#solutions" },
      { label: "Why CodeIntel", href: "#why-us" },
      { label: "Contact", href: "#contact" },
    ],
  };

  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Top CTA */}
        <div className="border border-[#00E599]/15 rounded-2xl p-8 md:p-12 mb-16 bg-[#00E599]/3 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3
              className="text-2xl md:text-3xl font-bold text-white mb-2"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Ready to transform your business with AI?
            </h3>
            <p className="text-[#A1A1AA]">Book a free strategy call with our AI experts.</p>
          </div>
          <a
            href="#contact"
            data-testid="footer-cta-btn"
            className="flex-shrink-0 inline-flex items-center gap-2 bg-[#00E599] text-black font-semibold rounded-full px-7 py-3.5 hover:bg-[#00ff99] transition-colors"
          >
            Book Free Consultation
            <ArrowRight size={16} />
          </a>
        </div>

        {/* Main Footer Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <div className="w-8 h-8 rounded-lg bg-[#00E599]/10 border border-[#00E599]/25 flex items-center justify-center">
                <Brain size={18} className="text-[#00E599]" />
              </div>
              <span
                className="font-black text-base text-white"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                CodeIntel<span className="text-[#00E599]"> AI</span> Labs
              </span>
            </Link>
            <p className="text-sm text-[#71717A] leading-relaxed mb-5 max-w-[220px]">
              Building Agentic AI Platforms, AI Agents, and Vertical SaaS Products that transform industries.
            </p>
            <div className="flex flex-col gap-1">
              <a
                href="tel:+919958891551"
                className="text-sm text-[#A1A1AA] hover:text-[#00E599] transition-colors"
              >
                +91 99588 91551
              </a>
              <a
                href="https://wa.me/919958891551?text=Hi%20CodeIntel%20AI%20Labs,%20I%20am%20interested%20in%20AI%20automation,%20AI%20agents,%20or%20a%20custom%20AI%20solution%20for%20my%20business.%20Let's%20discuss."
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-[#A1A1AA] hover:text-[#00E599] transition-colors"
              >
                WhatsApp Us
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4
                className="text-sm font-semibold text-white mb-4 tracking-wide"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link
                        to={link.to}
                        className="text-sm text-[#71717A] hover:text-[#A1A1AA] transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-sm text-[#71717A] hover:text-[#A1A1AA] transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#71717A]">
            © {currentYear} CodeIntel AI Labs. All rights reserved.
          </p>
          <p className="text-xs text-[#71717A]">
            Building the Future with Agentic AI
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
